module.exports = __webpack_public_path__ + "img/hyll-logo-dark.d03561dc.svg";